import get from 'lodash/get';
import { takeEvery, put, select } from 'redux-saga/effects';

import { consts as caregiverCirclesConsts } from '../circles/caregiver';
import { consts as getDependentsListConsts } from '../profiles/get-guardian-dependents';
import { consts as targetUserConsts } from './targetUser';
import { consts as loggedUserConsts } from './loggedUser';
import { consts as permissionsConsts } from './permissions';
import { selectVerifiedGuardianDependentsList } from '../profiles/selectors';

// actions
const GET_CAREGIVER_CIRCLES = caregiverCirclesConsts.SUCCEED;
const ADD_LOGGED_USER = loggedUserConsts.ADD;
const UPDATE_LOGGED_USER = loggedUserConsts.UPDATE;
const REMOVE_LOGGED_USER = loggedUserConsts.REMOVE;
const SET_TARGET_USER = targetUserConsts.SET;
const REMOVE_TARGET_USER = targetUserConsts.REMOVE;
const GET_DEPENDENTS_LIST = getDependentsListConsts.SUCCEED;

/*
 * Saga for updating caregiver circles to context/permissions state
 */
function* updateCaregiverCirclesWorker(action) {
  const caregiverCircles = action.payload.map(circle => circle.id);

  yield put({
    type: permissionsConsts.UPDATE,
    payload: { caregiverCircles },
  });
}

export function* updateCaregiverCirclesSaga() {
  yield takeEvery([GET_CAREGIVER_CIRCLES], updateCaregiverCirclesWorker);
}

function* updateDependentsListWorker() {
  const verifiedDependentsList = yield select(
    selectVerifiedGuardianDependentsList,
  );
  const dependentsIdList = verifiedDependentsList.map(item =>
    get(item, 'dependent.id'),
  );
  yield put({
    type: permissionsConsts.UPDATE,
    payload: { dependentsList: dependentsIdList },
  });
}

export function* updateDependentsListSaga() {
  yield takeEvery([GET_DEPENDENTS_LIST], updateDependentsListWorker);
}

/*
 * Saga for updating logged user id to context/permissions state
 */

function* updateLoggedUserWorker(action) {
  const { payload } = action;
  const loggedUserId =
    get(payload, 'user.id') || get(payload, 'authentication.user.id');

  yield put({
    type: permissionsConsts.UPDATE,
    payload: { loggedUserId },
  });
}

export function* updateLoggedUserIdSaga() {
  yield takeEvery(
    [ADD_LOGGED_USER, UPDATE_LOGGED_USER, REMOVE_LOGGED_USER],
    updateLoggedUserWorker,
  );
}

/*
 * Saga for updating target user id to context/permissions state
 */

function* updateTargetUserWorker(action) {
  const targetUserId = get(action.payload, 'id');

  yield put({
    type: permissionsConsts.UPDATE,
    payload: {
      targetUserId,
      targetUser: action.payload,
    },
  });
}

export function* updateTargetUserIdSaga() {
  yield takeEvery(
    [SET_TARGET_USER, REMOVE_TARGET_USER],
    updateTargetUserWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/context/permissionsSaga.js